import React, { useState, useEffect } from "react";
import Paper from "@material-ui/core/Paper";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Checkbox from "@material-ui/core/Checkbox";
import { Button, Row, Col, Form, Alert } from "react-bootstrap";
import CircularProgress from "@mui/material/CircularProgress";
import * as XLSX from "xlsx";
import AADService from "../funcionesAuth.js";

function AlertDismissibleExample({ alerta }) {
  switch (alerta) {
    case 1:
      return <Alert variant="success">Guardó exitosamente</Alert>;
    case 2:
      return <Alert variant="warning">Error al enviar la información</Alert>;
    case 3:
      return <Alert variant="danger">Error en el servidor</Alert>;
    default:
      return <></>;
  }
}

const ControlesAdherencia = ({ idrol }) => {
  const [data, setData] = useState([]);
  const [cambios, setCambios] = useState({});
  const [estadoPOST, setEstadoPost] = useState(0);
  const [loading, setLoading] = useState(false);
  const esAdmin = Number(localStorage.getItem("rolusuario")) === 1;
  const AzureADService = new AADService();
  const token = AzureADService.getToken();

  const columnasFijas = [
    { field: "idimplementador", title: "Id Control" },
    { field: "nombre", title: "Nombre Control" },
  ];

  const columnsnames = {
    "15": "Participar en \ninteracciones engañosas",
    "16": "Abusar de funcionalidad existente",
    "17": "Manipular estructuras de datos",
    "18": "Manipular recursos del sistema",
    "19": "Inyectar elementos inesperados",
    "20": "Emplear técnicas probabilísticas",
    "21": "Manipular la sincronización y el estado",
    "22": "Recopilar y analizar información",
    "23": "Alterar el control de acceso"
  };

  const columnasID = Object.keys(data[0] || {}).filter(
    (k) => !["idimplementador", "nombre"].includes(k)
  );

  const handleCheckboxChange = (rowIndex, columnKey) => {
    const id = data[rowIndex].idimplementador;
    const nuevosCambios = { ...cambios };
    if (!nuevosCambios[id]) {
      nuevosCambios[id] = { ...data[rowIndex] };
    }
    nuevosCambios[id][columnKey] = nuevosCambios[id][columnKey] ? 0 : 1;
    setCambios(nuevosCambios);
  };

  const handleGuardar = async () => {
    try {
      const payload = Object.values(cambios).map((cambio) => ({
        idimplementador: cambio.idimplementador,
        ...cambio,
      }));

      const result = await fetch(
        process.env.REACT_APP_API_URL +
          "maestro/amenazas/adherencia/" +
          localStorage.getItem("idcompania"),
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,

          },
          body: JSON.stringify(payload),
        }
      );

      if (result.ok) {
        setEstadoPost(1);
        setCambios({});
      } else {
        setEstadoPost(2);
      }
      console.log(payload)
    } catch (error) {
      console.error("Error al guardar", error);
      setEstadoPost(3);
    }
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const result = await fetch(
        process.env.REACT_APP_API_URL +
          "maestro/amenazas/adherencia/" +
          localStorage.getItem("idcompania"),
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );
      if (result.ok) {
        const res = await result.json();
        setData(res);
      } else {
        setData([]);
      }
    } catch (err) {
      console.error("Error al obtener datos", err);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  const descargarXLSX = () => {
    if (!data.length) return;

    const dataXLSX = data.map((row) => {
      const fila = {};
      fila["Id"] = row.idimplementador;
      fila["Nombre"] = row.nombre;
      columnasID.forEach((col) => {
        const nombreColumna = columnsnames[col] || col;
        fila[nombreColumna] = row[col] === 1 ? "Verdadero" : "Falso";
      });
      return fila;
    });

    const headers = ["Id", "Nombre", ...columnasID.map(col => columnsnames[col] || col)];
    const worksheet = XLSX.utils.json_to_sheet(dataXLSX, { header: headers });
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Adherencias");

    XLSX.writeFile(workbook, "control-adherencias.xlsx");
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <AlertDismissibleExample alerta={estadoPOST} />

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "1rem",
        }}
      >
        <Row className="pl-3 pt-3 pb-3" style={{ alignItems: "center" }}>
                <Col sm={8}>
                  <h2 className="titulo" style={{ whiteSpace: "nowrap" }}>Controles de Adherencia</h2>
                </Col>
        </Row>
        <Button className="botonPositivo" variant="secondary" onClick={descargarXLSX}>
          Descargar adherencias
        </Button>
      </div>

      {loading ? (
        <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
          <CircularProgress />
        </div>
      ) : (
        <Form id="formData">
          <Paper style={{ maxWidth: "100%", overflowX: "auto" }}>
            <TableContainer style={{ maxHeight: "70vh" }}>
              <Table stickyHeader style={{ position: "relative" }}>
                <TableHead style={{ top: "0", zIndex: "1", position: "sticky" }}>
                  <TableRow>
                    {columnasFijas.map((col) => (
                      <TableCell
                        key={col.field}
                        style={{ backgroundColor: "#2c2a29", color: "#ffffff" }}
                      >
                        {col.title}
                      </TableCell>
                    ))}
                    {columnasID.map((col) => (
                      <TableCell
                        key={col}
                        style={{
                          backgroundColor: "#2c2a29",
                          color: "#ffffff",
                          textAlign: "center",
                          whiteSpace: "pre-line",
                        }}
                      >
                        {columnsnames[col] || col}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {data.map((row, rowIndex) => (
                    <TableRow key={row.idimplementador}>
                      {columnasFijas.map((col) => (
                        <TableCell key={col.field}>{row[col.field]}</TableCell>
                      ))}
                      {columnasID.map((columnKey) => (
                        <TableCell key={columnKey} style={{ textAlign: "center" }}>
                          <Checkbox
                            checked={
                              cambios[row.idimplementador]?.[columnKey] === 1 ||
                              (cambios[row.idimplementador]?.[columnKey] === undefined &&
                                row[columnKey] === 1)
                            }
                            onChange={() => handleCheckboxChange(rowIndex, columnKey)}
                            disabled={!esAdmin}
                          />
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>

          <Row>
            <Col sm={12}> &nbsp; </Col>
          </Row>

          <Row className="mb-3">
            <Col sm={4} xs={1}></Col>
            {esAdmin && (
              <Col sm={3} xs={3}>
                <Button onClick={handleGuardar} className="botonPositivo">
                  Guardar
                </Button>
              </Col>
            )}
          </Row>
        </Form>
      )}
    </>
  );
};

export default ControlesAdherencia;
